function detectOptimizelyExperiments() {
  var analyticsAllowed =
    (window.trackingConsentOptions && window.trackingConsentOptions.analytics) ||
    (window.Shopify &&
      window.Shopify.customerPrivacy &&
      typeof window.Shopify.customerPrivacy.analyticsProcessingAllowed === 'function' &&
      window.Shopify.customerPrivacy.analyticsProcessingAllowed()) ||
    false;
  // console.log('analyticsAllowed', analyticsAllowed);
  if (!analyticsAllowed) return;

  var optimizelyState =
    window.optimizely &&
    typeof window.optimizely.get === 'function'
      ? window.optimizely.get('state')
      : null;

  if (
    !optimizelyState ||
    typeof optimizelyState.getExperimentStates !== 'function'
  ) {
    console.warn('Optimizely is not available or not ready.');
    return;
  }

  var experiments = optimizelyState.getExperimentStates() || {};
  var isActive = false;
  var experimentName = null;
  var variationName = null;
  // console.log('experiments', experiments);

  for (var experimentId in experiments) {
    if (experiments.hasOwnProperty(experimentId)) {
      var experiment = experiments[experimentId];
      isActive = experiment.isActive;
      experimentName = experiment.experimentName;
      variationName = experiment.variation.name;
      // console.log("Experiment ID: " + experimentId + ", Experiment Name: " + experimentName);
      // console.log("Variation ID: " + experiment.variation.id + ", Variation Name: " + variationName);
    }
  }

  if (isActive) {
    // console.log("Experiment is active");
    variationName = variationName.toLowerCase();
    applyVariation(experimentName, variationName);
  } else {
    document.body.classList.remove('has-optimizely');
    document.body.dispatchEvent(new CustomEvent('optimizely-ready'));
    document.body.classList.add('loaded');
    console.log('Experiment is not active');
  }
}
setTimeout(() => {
  detectOptimizelyExperiments();
}, 1500);
// applyVariation('Shop CTA', 'quickshop only without button');
function applyVariation(experiment, variation) {

  switch (true) {
    case experiment === 'Shop CTA' && variation === 'quickshop only with button':
      setButtonHeight();
      document.querySelectorAll('.card').forEach(card => {
        wrapCardWithModalOpener(card);
      });
      break;
    case experiment === 'Shop CTA' && variation === 'quickshop only without button':
      document.querySelectorAll('.card').forEach(card => {
        wrapCardWithModalOpener(card);
      });
      break;
    case experiment === 'Shop CTA' && variation === 'pdp without button':
      unsetPointerEvents();
      document.querySelectorAll('button.quick-add__submit').forEach(button => {
        button.classList.add('hidden');
      });
      break;
    case experiment === 'Shop CTA' && variation === 'add to cart button':
      setButtonHeight();
      unsetPointerEvents();
      document.querySelectorAll('.quick-add').forEach(cta => {
        const submitButton = cta.querySelector('.add__submit');
        const variantId = submitButton ? submitButton.getAttribute('data-product-variant-id') : null;
        const quickShopButton = cta.querySelector('.modal-link button');
        const inStock = quickShopButton ? !quickShopButton.classList.contains('notify') : true;
        if (quickShopButton && inStock) quickShopButton.textContent = getDirectTextContent(submitButton);
        const personalizationModal = cta.querySelector('.personalization-modal');
        const hasPersonalization = cta.querySelector('.has-personalization');
        if (personalizationModal) {
          cta.querySelector('.modal-link').classList.add('hidden');
          personalizationModal.classList.remove('hidden');
        } else if (!hasPersonalization && variantId) {
          cta.querySelector('.modal-link').classList.add('hidden');
          submitButton.classList.remove('hidden');
          submitButton.addEventListener('click', async (e) => {
            e.preventDefault();
            const data = {
              id: parseInt(variantId),
              quantity: 1,
              sections: [],
            };
            await cartAction('add', data);
          });
        }
      });
      break;
    case experiment === 'Shop CTA' && variation === 'original':
      setButtonHeight();
      unsetPointerEvents();
      break;
    default:
      break;
  }
  // console.log('setting optimizely-ready');
  document.body.dispatchEvent(new CustomEvent('optimizely-ready'));
  document.body.classList.add('loaded');
  if (isTouchDevice()) {
    document.querySelectorAll('.quick-add').forEach(cta => {
      cta.style.visibility = 'visible';
    });
  }
}

function wrapCardWithModalOpener(card) {
  const quickAddOpener = card.querySelector('modal-opener');
  if (!quickAddOpener) return;
  card.querySelectorAll('a').forEach(link => {
    link.addEventListener('click', (e) => {
      e.preventDefault();
    });
  });
  const modalId = quickAddOpener.getAttribute('data-modal');
  const quickAddButton = card.querySelector('button.quick-add__submit');
  const productUrl = quickAddButton.getAttribute('data-product-url') || quickAddOpener.getAttribute('data-product-url');
  const cardMedia = card.querySelector('.card__media');
  cardMedia.setAttribute('data-product-url', productUrl);
  cardMedia.addEventListener('click', (e) => {
    e.preventDefault();
    openModal(card, modalId, cardMedia);
  });
  const cardText = card.querySelector('.card__inner').nextElementSibling;
  cardText.setAttribute('data-product-url', productUrl);
  // cardText.querySelector('a').style.pointerEvents = 'none';
  cardText.addEventListener('click', (e) => {
    e.preventDefault();
    openModal(card, modalId, cardText);
  });
}

function openModal(card, modalId, opener) {
  card.querySelector('.card-spinner').classList.remove('hidden');
  card.querySelector('.loading__spinner').classList.remove('hidden');
  const modal = document.querySelector(modalId);
  modal.show(opener);
}

function setButtonHeight() {
  document.querySelectorAll('.quick-add').forEach(cta => {
    const height = cta.querySelector('button').clientHeight;
    if (height) cta.style.height = `${height}px`;
  });
}

function unsetPointerEvents() {
  document.querySelectorAll('.product-card-wrapper a').forEach(link => {
    link.style.pointerEvents = 'auto';
  });
}

function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

function getDirectTextContent(element) {
  let directText = '';
  const childNodes = element.childNodes;

  for (let i = 0; i < childNodes.length; i++) {
    const node = childNodes[i];
    // Check if the node is a Text Node (nodeType 3 or Node.TEXT_NODE)
    if (node.nodeType === Node.TEXT_NODE) {
      directText += node.textContent;
    }
  }
  return directText.trim(); // Use trim() to remove leading/trailing whitespace
}